<template>
  <div class="user-list">
    <!-- 学员卡片列表 -->
    <div v-for="(item, index) in userListData" :key="item.id || index" class="card" :class="{
      boy: item.is_sex === 1,
      girl: item.is_sex === 0,
      'can-click': canClickCard
    }" @click="handleCardClick(item)">
      <el-row type="flex" align="middle" :gutter="10">
        <!-- 左侧信息 -->
        <el-col :span="8">
          <div class="card-item name">
            {{ item.user_name || '--' }}
            <el-image class="edit-icon" :src="require('@/assets/new_icon/edit.png')" @click.stop="handleEdit(item)" />
          </div>
          <div class="card-item score">{{ formatScore(item.score) }}</div>
          <div class="card-item subject">{{ formatSubject(item) }}</div>
        </el-col>

        <!-- 右侧信息 -->
        <el-col :span="16" :offset="1">
          <div class="card-item school">{{ item.school || '未填写' }}</div>
          <div class="card-item">填报批次</div>
          <div class="card-item status">
            填报状态：
            <span :class="getStatusClass(item.status)">
              {{ getStatusText(item.status) }}
            </span>
          </div>
        </el-col>
      </el-row>

      <!-- 审核状态标签（如果有） -->
      <div v-if="item.auditStatus" class="audit-tag" :class="`audit-${item.auditStatus}`">
        {{ getAuditText(item.auditStatus) }}
      </div>
    </div>

    <!-- 空状态 -->
    <div v-if="!userListData.length" class="empty-state">
      <el-empty description="暂无学员数据" :image-size="120" />
    </div>

    <!-- 编辑学员抽屉 -->
    <el-drawer :visible.sync="dialogEditVisible" title="修改个人信息" :with-header="false" size="1220px" destroy-on-close>
      <editUser :userData="currentEditUser" handleState="handleState" @closeEdit="handleCloseEdit" />
    </el-drawer>
  </div>
</template>

<script>
import editUser from './editUser'

export default {
  name: 'UserList',
  components: {
    editUser,
  },
  props: {
    // 学员列表数据
    userListData: {
      type: Array,
      default: () => [],
    },
    // 专家列表（未使用，保留）
    expertList: {
      type: Array,
      default: () => [],
    },
    // 处理状态：3 表示只读模式
    handleState: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      dialogEditVisible: false,
      currentEditUser: null,
      expertInfo: null,
      dialogEdit:true
    }
  },
  computed: {
    /**
     * 卡片是否可点击
     */
    canClickCard() {
      return this.handleState != 3
    },
  },
  created() {
    this.init()
  },
  methods: {
    /**
     * 初始化
     */
    init() {
      const expertInfoStr = localStorage.getItem('ExpertInfo')
      if (expertInfoStr) {
        this.expertInfo = JSON.parse(expertInfoStr)
      }
    },

    /**
     * 格式化分数
     */
    formatScore(score) {
      if (score === null || score === undefined) return '暂无分数'
      return `${score}分`
    },

    /**
     * 格式化选科信息
     * @param {Object} item - 学员信息
     */
    formatSubject(item) {
      const { subject, other_subject: otherSubject } = item
      if (!subject) return '未选科'

      // 科目映射表
      const subjectMap = {
        1: '物',
        2: '化',
        3: '生',
        4: '史',
        5: '地',
        6: '政',
      }

      let result = subjectMap[subject] || ''

      // 解析并格式化其他科目
      if (otherSubject) {
        try {
          const subjects = typeof otherSubject === 'string'
            ? JSON.parse(otherSubject)
            : otherSubject
          if (Array.isArray(subjects)) {
            result += subjects.map(s => subjectMap[s] || '').join('')
          }
        } catch (error) {
          console.error('解析选科数据失败:', error)
        }
      }

      return result || '未选科'
    },

    /**
     * 获取状态文本
     */
    getStatusText(status) {
      const statusMap = {
        0: '未填',
        1: '未填',
        2: '未填',
      }
      return statusMap[status] || '未知'
    },

    /**
     * 获取状态样式类
     */
    getStatusClass(status) {
      const classMap = {
        0: 'status-pending',
        1: 'status-done',
        2: 'status-submitted',
      }
      return classMap[status] || ''
    },              

    /**
     * 获取审核状态文本
     */
    getAuditText(auditStatus) {
      const auditMap = {
        1: '审核中',
        2: '已通过',
        3: '已拒绝',
      }
      return auditMap[auditStatus] || ''
    },

    /**
     * 处理卡片点击（跳转到填报页面）
     */
    handleCardClick(item) {
      // 只读模式或没有 ID 时不跳转
      if (!this.canClickCard || !item.id) return

      this.$router.push({
        path: '/tianbao',
        query: {
          id: item.id,
          score: item.score,
          subject: item.subject,
          nav_id: 3,
        },
      })
    },

    /**
     * 处理编辑
     */
    handleEdit(item) {
      this.currentEditUser = { ...item } // 深拷贝避免引用
      this.dialogEditVisible = true
    },

    /**
     * 关闭编辑抽屉并刷新列表
     */
    handleCloseEdit() {
      this.dialogEditVisible = false
      this.currentEditUser = null
      this.$emit('refresh') // 触发父组件刷新
    },
  },
}
</script>

<style lang="less" scoped>
.user-list {
  min-height: 700px;

  .card {
    display: inline-block;
    width: 420px;
    height: 125px;
    margin-bottom: 12px;
    margin-right: 6px;
    padding: 15px 10px 10px 25px;
    border-radius: 5px;
    position: relative;
    transition: all 0.3s ease;
    cursor: default;

    // 可点击状态
    &.can-click {
      cursor: pointer;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }
    }

    // 男生卡片样式
    &.boy {
      background: linear-gradient(92deg, #ADC6F9 11%, #FFFFFF 59%);
      border: 2px solid #ADC6F9;
    }

    // 女生卡片样式
    &.girl {
      background: linear-gradient(92deg, #FF82A4 10%, #FFFFFF 58%);
      border: 2px solid #FF82A4;
    }

    .card-item {
      margin-bottom: 13px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      position: relative;
      line-height: 21px;
      height: 21px;

      &.name {
        font-size: 22px;
        line-height: 24px;
        height: 24px;
        padding-right: 24px;

        .edit-icon {
          position: absolute;
          top: 0;
          right: 0;
          width: 18px;
          height: 18px;
          cursor: pointer;
          opacity: 0.6;
          transition: opacity 0.2s;

          &:hover {
            opacity: 1;
          }
        }
      }

      &.score {
        font-weight: 500;
        color: #333;
      }

      &.school {
        font-weight: 500;
        color: #333;
      }

      &.status {
        .status-pending {
          color: #ff9800;
        }

        .status-done {
          color: #4caf50;
        }

        .status-submitted {
          color: #2196f3;
        }
      }
    }

    // 审核标签
    .audit-tag {
      position: absolute;
      right: 14px;
      bottom: 14px;
      display: inline-block;
      padding: 2px 12px;
      border-radius: 30px;
      font-size: 14px;

      &.audit-1 {
        background: #E0EDFF;
        color: #FF9800;
      }

      &.audit-2 {
        background: #E0F5E8;
        color: #4CAF50;
      }

      &.audit-3 {
        background: #FFEBEE;
        color: #F44336;
      }
    }
  }

  // 空状态样式
  .empty-state {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
    padding: 40px 0;
  }
}
</style>